export default "__VITE_ASSET__BXzy8KkE__"